/* eslint-disable no-param-reassign */
import produce from 'immer';
import _ from 'lodash';
import {
  GET_BOTS,
  ADD_BOT,
  DELETE_BOTS,
  UPDATE_BOT,
  SHOW_BOT_ACTIONS,
  HIDE_BOT_ACTIONS,
  LOAD_AVAILABLE_STAFF,
  LOAD_AVAILABLE_STAFF_SUCCESS,
  LOAD_AVAILABLE_STAFF_ERROR
} from 'src/actions/botsActions';
import objFromArray from 'src/utils/objFromArray';

const initialState = {
  showBotActions: false,
  byId: {},
  allIds: [],
  availableStaff: {},
  staffLoading: {},
  staffErrors: {},
  staffLoaded: {}
};

const botReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOTS: {
      const { bots } = action.payload;

      return produce(state, draft => {
        draft.byId = objFromArray(bots);
        draft.allIds = Object.keys(draft.byId);
      });
    }

    case ADD_BOT: {
      const { bot } = action.payload;
      return produce(state, draft => {
        draft.byId[bot.id] = bot;
        if (!draft.allIds.includes(bot.id)) {
          draft.allIds.push(bot.id);
        }
      });
    }

    case DELETE_BOTS: {
      const { botId } = action.payload;
      return produce(state, draft => {
        draft.byId = _.omit(draft.byId, botId);
        draft.allIds = draft.allIds.filter(id => id !== botId);
      });
    }

    case UPDATE_BOT: {
      const { bot } = action.payload;
      return produce(state, draft => {
        draft.byId[bot.id] = bot;
      });
    }

    case SHOW_BOT_ACTIONS: {
      return produce(state, draft => {
        draft.showBotActions = true;
      });
    }
    case HIDE_BOT_ACTIONS: {
      return produce(state, draft => {
        draft.showBotActions = false;
      });
    }

    case LOAD_AVAILABLE_STAFF: {
      const { botId } = action.payload;
      return produce(state, draft => {
        draft.staffLoading[botId] = true;
        draft.staffErrors[botId] = null;
        draft.staffLoaded[botId] = false;
      });
    }

    case LOAD_AVAILABLE_STAFF_SUCCESS: {
      const { botId, staff } = action.payload;
      return produce(state, draft => {
        draft.availableStaff[botId] = staff;
        draft.staffLoading[botId] = false;
        draft.staffErrors[botId] = null;
        draft.staffLoaded[botId] = true;
      });
    }

    case LOAD_AVAILABLE_STAFF_ERROR: {
      const { botId, error } = action.payload;
      return produce(state, draft => {
        draft.staffLoading[botId] = false;
        draft.staffErrors[botId] = error;
        draft.staffLoaded[botId] = true;
      });
    }

    default: {
      return state;
    }
  }
};

export default botReducer;
